import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {Breadcrumb, Col, Container, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faGift, faShoppingBasket, faSearch, faList, faBan} from '@fortawesome/free-solid-svg-icons';
import HelperGeneral from '../../../helpers/HelperGeneral';
import UserInfo from '../../auth/UserInfo';
import Api from '../../../services/Api';
import {Button, Drawer, Empty, Spin} from 'antd';
import {setBasketList, setRightBasketModal} from '../../../services/redux/actions/BasketAction';
import BasketInfo from './basket/BasketInfo';
import {connect} from 'react-redux';
import CategorySideBar from "../../partials/CategorySideBar";

const PAGE_SIZE = 10;
const categorySlugFromMatch = (match) => match?.params?.category_id + '/' + match?.params?.sub_id;

class Category extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            slug: categorySlugFromMatch(this.props?.match),
            loading: true,
            products: [],
            page: 1,
            hasMore: true,
            loadingMore: false,
            mobileCategoryVisible: false,
            width: window.innerWidth,
            sideBarData: [],
            user: UserInfo.info(),
            basketAddLoading: false,
            productToBeAddedId: null
        }
        this.loadMoreRef = React.createRef();
        this.scrollObserver = null;
    }

    updateWidth = () => {
        this.setState({width: window.innerWidth});
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateWidth);
        this.getProducts();
        this.setupScrollObserver();

        Api.getCustomer().then(r2 => {
            const {remember} = UserInfo.dataCheck();
            UserInfo.setUserInfo(r2?.data, remember);
        }).catch((e) => {
            HelperGeneral.alert(e);
        });

        this.setPriceListLocalStorage();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const slug = categorySlugFromMatch(this.props?.match)
        if (this.state.slug !== slug) {
            this.setState({slug, page: 1, hasMore: true}, () => this.getProducts());
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
        if (this.scrollObserver && this.loadMoreRef.current) {
            this.scrollObserver.unobserve(this.loadMoreRef.current);
        }
    }

    getPriceList() {
        Api.getPriceList().then((e) => {
            const expiry = Date.now() + 15 * 60 * 1000;
            const data = {
                value: e?.data,
                expiry
            };

            localStorage.setItem("priceListInfo", JSON.stringify(data));
            this.setState({priceListInfo: e?.data});
        }).catch((e) => {
            HelperGeneral.alert(e);
        })
    }

    setPriceListLocalStorage() {
        const stored = localStorage.getItem("priceListInfo");

        if (stored) {
            const parsed = JSON.parse(stored);

            if (Date.now() > parsed?.expiry) {
                localStorage.removeItem("priceListInfo");
                this.getPriceList();
            } else {
                this.setState({priceListInfo: parsed?.value});
            }
        } else {
            this.getPriceList();
        }
    }

    setupScrollObserver = () => {
        const options = {root: null, rootMargin: '200px', threshold: 0};
        this.scrollObserver = new IntersectionObserver((entries) => {
            const [entry] = entries;
            if (entry?.isIntersecting) this.loadMoreProducts();
        }, options);
        if (this.loadMoreRef.current) {
            this.scrollObserver.observe(this.loadMoreRef.current);
        }
    };

    getProducts() {
        const {slug} = this.state;
        this.setState({products: [], page: 1, hasMore: true, loading: true}, () => {
            Api.getProducts(slug, 1, PAGE_SIZE).then((response) => {
                const data = response?.data?.data ?? [];
                this.setState({
                    loading: false,
                    products: data,
                    hasMore: data.length >= PAGE_SIZE,
                }, () => {
                    setTimeout(() => {
                        if (this.loadMoreRef.current && this.scrollObserver) {
                            this.scrollObserver.observe(this.loadMoreRef.current);
                        }
                    }, 0);
                });
            }).catch(e => {
                this.setState({loading: false}, () => HelperGeneral.alert(e));
            });
        });
    }

    loadMoreProducts = () => {
        const {slug, page, hasMore, loadingMore, products} = this.state;
        if (!hasMore || loadingMore) return;
        this.setState({loadingMore: true}, () => {
            Api.getProducts(slug, page + 1, PAGE_SIZE).then((response) => {
                const data = response?.data?.data ?? [];
                this.setState({
                    loadingMore: false,
                    products: [...products, ...data],
                    page: page + 1,
                    hasMore: data.length >= PAGE_SIZE,
                });
            }).catch(e => {
                this.setState({loadingMore: false}, () => HelperGeneral.alert(e));
            });
        });
    };

    showDrawer = () => {
        this.setState({mobileCategoryVisible: true});
    };

    onClose = () => {
        this.setState({mobileCategoryVisible: false});
    };

    setSideBarData = (data) => {
        this.setState({sideBarData: data});
    };

    setBasketItem = (item, quantity = 1) => {
        this.setState({basketAddLoading: true, productToBeAddedId: item?.id});
        const basketRaw = localStorage.getItem("basketList");
        const basket = basketRaw ? JSON.parse(basketRaw) : {products: []};

        const products = Array.isArray(basket.products) ? basket.products : [];

        const exists = products.some(p => Number(p.product_id) === Number(item?.id));

        if (exists) {
            this.setState({basketAddLoading: false});
            HelperGeneral.alert("Ürün sepette bulunmaktadır", "warning");
            return;
        }

        if (products?.length === 1) {
            this.setState({basketAddLoading: false});
            HelperGeneral.alert("Aylık hediye ürün sipariş limiti 1 olduğu için ürün sepete eklenemedi.")
            return;
        }

        const data = {
            product_id: item?.id,
            quantity: quantity,
            type: 1,
            uniqid: Api.uuidv4(),
            gift_product: 1
        };

        Api.addBasket(data).then((res) => {
            Api.getBasket().then((response) => {
                if (response?.data.products?.length > 0) {
                    this.setState({basketAddLoading: false});
                    localStorage.setItem("basketList", JSON.stringify(response?.data));
                    setBasketList(response?.data?.products);
                    setRightBasketModal(true);
                } else {
                    this.setState({basketAddLoading: false});
                    localStorage.removeItem("basketList");
                    setBasketList([]);
                }
            }).catch((e) => {
                this.setState({basketAddLoading: false});
                HelperGeneral.alert(e);
            });
        });
    }

    render() {
        const {
            products,
            loading,
            loadingMore,
            hasMore,
            mobileCategoryVisible,
            width,
            sideBarData,
            slug,
            user,
            basketAddLoading,
            productToBeAddedId,
            priceListInfo
        } = this.state;

        const selectedCategory = sideBarData?.find(data => data?.slug === slug);
        const categoryOverlayColor = selectedCategory ? selectedCategory?.overlayColor : undefined;

        return (
            <div className={'product-category consumer-category pb-1 pb-sm-4 min-height-container'}>
                <Container>
                    <Row>
                        <Col xs={12} className={'mt-2 mb-4'}>
                            <Row>
                                <Col xs={12} md={9} className={'mx-auto'}>
                                    <div className={'gift-box'}>
                                        <Row className={'h-100'}>
                                            <Col xs={'auto'} className={'my-auto mx-auto'}>
                                                <div className={'icon'}>
                                                    <img
                                                        src={require('../../../assets/images/png/theme/q-point-logo-transparent.png')}/>
                                                </div>
                                            </Col>
                                            <Col xs={true} className={'my-auto pt-2 pb-2'}>
                                                <div>Kazandığınız Q puanlar ile SHINIQ hediye ürünlerinizi
                                                    seçebilirisiniz.
                                                </div>
                                            </Col>
                                            <Col lg={'auto'} className="pl-0 pr">
                                                <div className="r">
                                                    <div className="r1">
                                                        TOPLAM PUANINIZ
                                                    </div>
                                                    <div className="r2">
                                                        <span
                                                            className="r2_1">{user?.score ? HelperGeneral.formatNumber(user?.score) : '0'}</span>
                                                        <span className="r2_2">
                                                            <img
                                                                src={require('../../../assets/images/png/theme/q-point-logo-transparent.png')}
                                                                className={'q-point-logo-small'}
                                                                alt={'q-point-logo'}
                                                            /> PUAN
                                                        </span>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} className={'mb-1 mb-sm-3'}>
                            <h4>Ürün Kategorisi</h4>
                            <Breadcrumb>
                                <Breadcrumb.Item href={"/home"}>Ana Sayfa</Breadcrumb.Item>
                                <Breadcrumb.Item>Ürünler</Breadcrumb.Item>
                                <Breadcrumb.Item active={true}>Kategoriler</Breadcrumb.Item>
                            </Breadcrumb>
                        </Col>
                        <Col md={12} lg={3} xxl={3}>
                            {
                                width > 991 ? (
                                    <Row>
                                        <CategorySideBar setSideBarData={this.setSideBarData}/>
                                    </Row>
                                ) : (
                                    <Container className={'mobile-category-container p-0'}>
                                        <Row>
                                            <Col xs={12}>
                                                <div className={'mobile-category-div'}>
                                                    <button className={'category-btn'}
                                                            onClick={() => this.showDrawer()}>
                                                        <FontAwesomeIcon icon={faList}/>
                                                        <span>Kategoriler</span>
                                                    </button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Container>
                                )
                            }
                        </Col>
                        <Drawer
                            title={null}
                            placement={"left"}
                            closable={true}
                            onClose={this.onClose}
                            visible={mobileCategoryVisible}
                            width={300}
                            className={'mobile-category-drawer'}
                        >
                            <CategorySideBar setSideBarData={this.setSideBarData} onClose={this.onClose}/>
                        </Drawer>
                        <Col md={12} lg={9} xxl={9} className={'mt-0'}>
                            <Spin spinning={loading}>
                                <Row>
                                    {
                                        products?.length > 0 ? (
                                            <>
                                                {products?.map((v, i) => (
                                                    <Col className={'mb-4'} sm={6} lg={4} md={6} xxl={4}
                                                         key={v?.id ?? i}>
                                                        <div className={'product position-relative'}>
                                                            {
                                                                (v?.gift_product === 1 && v?.gift_point > 0) && (
                                                                    <div className={'position-absolute gift-enable-div'}>
                                                                        <div className={'gift-box-s m-0'} style={{
                                                                            backgroundColor: categoryOverlayColor,
                                                                            borderColor: categoryOverlayColor
                                                                        }}>
                                                                            <FontAwesomeIcon icon={faGift}
                                                                                             style={{fontSize: 16}}/>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                            <div className={'top'}>
                                                                <Link to={'/product/' + v?.slug}
                                                                      onClick={() => HelperGeneral.addToLastLookedItem(v, 1)}>
                                                                    <img
                                                                        src={v?.images[0]?.w600x ?? require('../../../assets/images/png/default-product.png')}
                                                                        alt={v?.name}/>
                                                                </Link>
                                                            </div>
                                                            <div className={'title'}>
                                                                <Link to={'/product/' + v?.slug}
                                                                      onClick={() => HelperGeneral.addToLastLookedItem(v, 1)}>{v?.name}</Link>
                                                            </div>
                                                            {
                                                                (v?.gift_product === 1 && v?.gift_point > 0) ? (
                                                                    <>
                                                                    <div className={'gift'}>
                                                                        <div className={'d-flex align-items-center'}>
                                                                            <span>{HelperGeneral.formatPoint(v?.gift_point)} </span>
                                                                            <img
                                                                                src={require('../../../assets/images/png/theme/q-point-logo.png')}
                                                                                className={'q-point-logo'}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        ((UserInfo.info('user_roles_id') === 4 || UserInfo.info('user_roles_id') === 6) && priceListInfo?.products && v?.id) && (
                                                                            <div className={'frame point mb-3'}>
                                                                                <div className={'gift'}>
                                                                                    <span>{HelperGeneral.formatMoneyTL(priceListInfo?.products[v?.id]?.price)}</span>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                            <div className={'text-center btn-col'}>
                                                                {
                                                                    v?.inStock < 1 ? (
                                                                        <Link
                                                                            className={'btn btn-primary-2 mt-3 mb-3 w-100'}
                                                                            to={'/product/' + v?.slug}
                                                                            style={{
                                                                                backgroundColor: categoryOverlayColor,
                                                                                borderColor: categoryOverlayColor
                                                                            }}
                                                                            onClick={() => HelperGeneral.addToLastLookedItem(v, 1)}
                                                                        >
                                                                            <FontAwesomeIcon icon={faBan}
                                                                                             className={'me-1'}/> Stok
                                                                            Tükendi
                                                                        </Link>
                                                                    ) : (
                                                                        <Button
                                                                            className={'btn btn-primary-2 mt-3 mb-3 w-100'}
                                                                            style={{
                                                                                backgroundColor: categoryOverlayColor,
                                                                                borderColor: categoryOverlayColor
                                                                            }}
                                                                            loading={productToBeAddedId ? (productToBeAddedId === v?.id && basketAddLoading) : basketAddLoading}
                                                                            onClick={() => {
                                                                                this.setBasketItem(v);
                                                                                HelperGeneral.addToLastLookedItem(v, 1);
                                                                            }}
                                                                        >
                                                                            <FontAwesomeIcon icon={faShoppingBasket}
                                                                                             className={'me-2'}/> Sepete
                                                                            Ekle
                                                                        </Button>
                                                                    )
                                                                }
                                                            </div>
                                                        </>
                                                        ) : (
                                                        <>
                                                            <div className={'gift'}>
                                                                <br/>
                                                            </div>
                                                            <div className={'text-center btn-col'}>
                                                                <Link
                                                                    className={'btn btn-primary-2 mt-3 mb-3 w-100'}
                                                                    to={'/product/' + v?.slug}
                                                                    style={{
                                                                        backgroundColor: categoryOverlayColor,
                                                                        borderColor: categoryOverlayColor
                                                                    }}
                                                                    onClick={() => HelperGeneral.addToLastLookedItem(v, 1)}
                                                                >
                                                                    <FontAwesomeIcon icon={faSearch}/> İncele
                                                                </Link>
                                                            </div>
                                                        </>
                                                        )
                                                        }
                                                    </div>
                                                    </Col>
                                                    ))}
                                                {hasMore && (
                                                    <Col xs={12} ref={this.loadMoreRef} className={'text-center py-4'}
                                                         style={{minHeight: 48}}>
                                                        <Spin spinning={loadingMore} size="small">
                                                            <span
                                                                className={loadingMore ? '' : 'opacity-0'}>Yükleniyor</span>
                                                        </Spin>
                                                    </Col>
                                                )}
                                            </>
                                        ) : (
                                            !loading && (
                                                <Empty description={'Ürün bulunamadı'}/>
                                            )
                                        )
                                    }
                                </Row>
                            </Spin>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}

export default withRouter(Category);
